import { PagedResult } from "@king-ict/eupisi-ui/models";

import type { Selectable } from "../../../models";

import { YesNoOption } from "./types";

export const getBooleanFilterValue = (
  value: boolean | null
): YesNoOption | undefined => {
  if (value === null) {
    return undefined;
  }

  return value ? YesNoOption.Yes : YesNoOption.No;
};

export const getBooleanFromSelectValue = (value?: string): boolean | null => {
  const parsedValue = Number.parseInt(value ?? "");

  if (isNaN(parsedValue) || parsedValue <= 0) {
    return null;
  }

  return parsedValue === YesNoOption.Yes;
};

type SelectableWithId = Selectable & {
  schoolCandidateId: number;
};

export const buildTableDataWithSelection = <T extends SelectableWithId>(
  tableData: PagedResult<T>,
  selectedIds: number[]
): PagedResult<T> => {
  const selectedIdSet = new Set(selectedIds);

  return {
    ...tableData,
    results: tableData.results.map((candidate) => {
      return {
        ...candidate,
        isSelected: selectedIdSet.has(candidate.schoolCandidateId),
      };
    }),
  };
};

